<form [formGroup]="form" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-stretch justify-start space-y-4">

    @if (!isLightVersion) {
        <div class="w-full space-y-3">
            <app-autocomplete
                class="w-full block"
                label="¿Cómo se llama la empresa para la que trabajas?"
                [items]="companies"
                labelKey="label"
                valueKey="value"
                [defaultValue]="defaultData?.company"
                [showBlocker]="true"
                (valueChange)="setCompany($event)"
            >
            </app-autocomplete>

            @if (isCheckData && dataLastOnboarding && dataLastOnboarding['company'] !== undefined) {
                <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
                    <div class="flex items-center gap-2">
                        <span class="text-xs text-label">Empresa anterior:</span>
                        <span class="font-medium text-base-content">
                            {{ getCompanyLabel(dataLastOnboarding['company']) }}
                        </span>
                    </div>
                </div>
            }
        </div>
    }

    @for (item of lightDataInputs(); track item.formName) {
        <div class="w-full space-y-3">
            <app-input
                class="w-full block"
                [config]="item"
                (submitValue)="handleValue($event)">
            </app-input>

            @if (isCheckData && dataLastOnboarding && dataLastOnboarding[item.formName ?? ''] !== undefined) {
                <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
                    <div class="flex items-center gap-2">
                        <span class="text-xs text-label">Anterior:</span>
                        <span class="font-medium text-base-content">
                            @if (item.formName === 'income' || item.formName === 'incomeExtraActivity') {
                                {{ dataLastOnboarding[item.formName] | number:'1.0-0' }}
                            } @else {
                                {{ dataLastOnboarding[item.formName ?? ''] }}
                            }
                        </span>
                    </div>
                    @if (item.formName === 'income' || item.formName === 'incomeExtraActivity') {
                        <span class="text-xs text-label">COP</span>
                    }
                </div>
            }
        </div>
    }

    @if (!isLightVersion) {
        <div class="w-full space-y-3">
            <app-selected
                class="w-full block"
                [config]="dataSelected().at(0)"
                (selectValue)="handleValue($event)"
            ></app-selected>

            @if (isCheckData && dataLastOnboarding && getFormNameFromSelected(0) && dataLastOnboarding[getFormNameFromSelected(0)] !== undefined) {
                <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
                    <div class="flex items-center gap-2">
                        <span class="text-xs text-label">Anterior:</span>
                        <span class="font-medium text-base-content">
                            {{ getOptionLabel(0, dataLastOnboarding[getFormNameFromSelected(0)]) }}
                        </span>
                    </div>
                </div>
            }
        </div>

        <div class="w-full space-y-3">
            <app-autocomplete
                label="¿Cuál es tu profesión?"
                [items]="codpros"
                labelKey="label"
                valueKey="value"
                [defaultValue]="defaultData?.codpro"
                [showBlocker]="true"
                (valueChange)="setCodpro($event)"
            >
            </app-autocomplete>

            @if (isCheckData && dataLastOnboarding && dataLastOnboarding['codpro'] !== undefined) {
                <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
                    <div class="flex items-center gap-2">
                        <span class="text-xs text-label">Profesión anterior:</span>
                        <span class="font-medium text-base-content">
                            {{ getProfessionLabel(dataLastOnboarding['codpro']) }}
                        </span>
                    </div>
                </div>
            }
        </div>

        <div class="w-full space-y-3">
            <app-selected
                class="w-full block"
                [config]="dataSelected().at(1)"
                (selectValue)="handleValue($event)"
            ></app-selected>

            @if (isCheckData && dataLastOnboarding && getFormNameFromSelected(1) && dataLastOnboarding[getFormNameFromSelected(1)] !== undefined) {
                <div class="flex items-center justify-between px-3 py-2 bg-base-200/50 rounded-lg border-l-2 border-primary shadow-xl">
                    <div class="flex items-center gap-2">
                        <span class="text-xs text-label">Anterior:</span>
                        <span class="font-medium text-base-content">
                            {{ getOptionLabel(1, dataLastOnboarding[getFormNameFromSelected(1)]) }}
                        </span>
                    </div>
                </div>
            }
        </div>
    }

</form>
